exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shop-product-options{text-align:center}.shop-product-options ul{padding:0;margin:0;list-style:none}", ""]);

// exports
